module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('xm-input', {
    attrs: {
      "id": "password-field",
      "type": _vm.showPass ? 'text' : 'password',
      "autocomplete": "false",
      "maxlength": _vm.maxlength,
      "label": _vm.label
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_c('span', {
    staticClass: "input-group-append",
    attrs: {
      "slot": "after"
    },
    on: {
      "click": function($event) {
        return _vm.updateShowPass(!_vm.showPass)
      }
    },
    slot: "after"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "bi icon-sizing",
    class: _vm.showPass ? 'bi-eye-slash-fill' : 'bi-eye-fill'
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e529c4d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShowPasswordField.vue
// module id = 1350
// module chunks = 16